import { OnboardingBusinessDetail, OnboardingQueueItem } from './admin.types';

export const MOCK_ONBOARDING_QUEUE: OnboardingQueueItem[] = [
  {
    id: '1',
    organizationName: 'QuantumLeap Analytics',
    email: 'hello@quantumleap.ai',
    xflowId: 'mock-customer-1',
    status: 'input_required',
    submittedDate: new Date('2025-06-12'),
  },
  {
    id: '2',
    organizationName: 'Synergy Corp',
    email: 'billing@zenith.io',
    xflowId: 'mock-customer-2',
    status: 'input_required',
    submittedDate: new Date('2025-06-18'),
  },
  {
    id: '3',
    organizationName: 'Meridian Holdings',
    email: 'support@pixelperfect.co',
    xflowId: 'mock-customer-3',
    status: 'input_required',
    submittedDate: new Date('2025-07-01'),
  },
  {
    id: '4',
    organizationName: 'Techcrop Solutions',
    email: 'contact@ecosolutions.com',
    xflowId: 'KYB-2025-004',
    status: 'in_review',
    submittedDate: new Date('2025-06-22'),
  },
  {
    id: '5',
    organizationName: 'Apex Fintech',
    email: 'orders@starlightretail.com',
    xflowId: 'KYB-2025-005',
    status: 'in_review',
    submittedDate: new Date('2025-07-05'),
  },
  {
    id: '6',
    organizationName: 'KDM Corp',
    email: 'admin@novasystems.com',
    xflowId: 'KYB-2025-006',
    status: 'approved',
    submittedDate: new Date('2025-05-30'),
  },
  {
    id: '7',
    organizationName: 'Patrick Inc',
    email: 'info@patrickinc.com',
    xflowId: 'KYB-2025-007',
    status: 'rejected',
    submittedDate: new Date('2025-05-28'),
  },
];

export const MOCK_ONBOARDING_BUSINESS_DETAILS: Record<
  string,
  OnboardingBusinessDetail
> = {
  '1': {
    id: '1',
    customerId: 'mock-customer-1',
    referenceId: 'mock-customer-1',
    organizationName: 'QuantumLeap Analytics',
    status: 'input_required',
    submittedDate: new Date('2025-06-12'),
    queries: [
      {
        queryId: 'query-1',
        status: 'PENDING',
        title: 'Proof of Business Address',
        description:
          "Please provide a utility bill, bank statement, or official government letter issued within the last 3 months confirming the company's registered address.",
      },
      {
        queryId: 'query-2',
        status: 'PENDING',
        title: 'Shareholder Register',
        description:
          'A certified copy of the current shareholder register listing all shareholders with 10% or more beneficial ownership.',
      },
      {
        queryId: 'query-3',
        status: 'PENDING',
        title: 'Director Identity Verification',
        description:
          'Valid government-issued photo ID for Director Priya Sharma. We accept a national passport or government-issued national ID card.',
      },
      {
        queryId: 'query-4',
        status: 'PENDING',
        title: 'Business Proof Required',
        description:
          'Submit any 2 of 4 documents: Shop and Establishment certificate, Udyam certificate, Sales tax or Service tax or Professional tax registration, or Utility bill including electricity, water, landline telephone.',
      },
    ],
    documents: [
      {
        id: 'doc-1',
        title: 'Certificate of Incorporation',
        status: 'verified',
        submittedDate: new Date('2025-06-12'),
        canDownload: true,
      },
      {
        id: 'doc-2',
        title: 'Memorandum & Articles of Association',
        status: 'under_review',
        submittedDate: new Date('2025-06-12'),
        canDownload: true,
      },
      {
        id: 'doc-3',
        title: 'Business PAN Card',
        status: 'verified',
        submittedDate: new Date('2025-06-12'),
        canDownload: true,
      },
      {
        id: 'doc-4',
        title: 'Business Proof, any 2 of 4',
        status: 'pending',
        submittedDate: new Date('2025-06-12'),
        canDownload: false,
      },
      {
        id: 'doc-5',
        title: 'Director ID — Rohan Mehta',
        status: 'verified',
        submittedDate: new Date('2025-06-12'),
        canDownload: true,
      },
      {
        id: 'doc-6',
        title: 'Director ID — Priya Nambiar',
        status: 'under_review',
        submittedDate: new Date('2025-06-12'),
        canDownload: true,
      },
      {
        id: 'doc-7',
        title: 'Shareholder Register',
        status: 'pending',
        submittedDate: new Date('2025-06-12'),
        canDownload: false,
      },
    ],
  },
  '2': {
    id: '2',
    customerId: 'mock-customer-2',
    referenceId: 'mock-customer-2',
    organizationName: 'Synergy Corp',
    status: 'input_required',
    submittedDate: new Date('2025-06-18'),
    queries: [
      {
        queryId: 'query-1',
        status: 'PENDING',
        title: 'PAN Verification Pending',
        description: 'Business PAN verification is pending.',
      },
    ],
    documents: [
      {
        id: 'doc-1',
        title: 'Certificate of Incorporation',
        status: 'verified',
        submittedDate: new Date('2025-06-18'),
        canDownload: true,
      },
      {
        id: 'doc-2',
        title: 'Business PAN Card',
        status: 'pending',
        submittedDate: new Date('2025-06-18'),
        canDownload: false,
      },
    ],
  },
  '3': {
    id: '3',
    customerId: 'mock-customer-3',
    referenceId: 'mock-customer-3',
    organizationName: 'Meridian Holdings',
    status: 'input_required',
    submittedDate: new Date('2025-07-01'),
    queries: [
      {
        queryId: 'query-1',
        status: 'PENDING',
        title: 'Business Proof Required',
        description:
          'Submit any 2 of 4 documents: Shop and Establishment certificate, Udyam certificate, Sales tax or Service tax or Professional tax registration, or Utility bill including electricity, water, landline telephone.',
      },
    ],
    documents: [
      {
        id: 'doc-1',
        title: 'Certificate of Incorporation',
        status: 'verified',
        submittedDate: new Date('2025-07-01'),
        canDownload: true,
      },
      {
        id: 'doc-2',
        title: 'Business Proof, any 2 of 4',
        status: 'pending',
        submittedDate: new Date('2025-07-01'),
        canDownload: false,
      },
    ],
  },
};

export function getMockBusinessDetail(
  id: string,
): OnboardingBusinessDetail | undefined {
  return MOCK_ONBOARDING_BUSINESS_DETAILS[id];
}
